var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          ref: "dropdown",
          attrs: { variant: "info", right: "", text: "Batch view" },
        },
        [
          _c("div", { staticClass: "px-3" }, [
            _c("label", { attrs: { for: "batch-region-list" } }, [
              _vm._v("Specify regions to plot (one per line):"),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.region_text,
                  expression: "region_text",
                },
              ],
              attrs: {
                id: "batch-region-list",
                rows: "10",
                placeholder: "chr:start-end or chr:pos",
              },
              domProps: { value: _vm.region_text },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.region_text = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm.message
              ? _c("div", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.message)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-end align-items-center" },
              [
                _vm.show_loader
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center spinner-border   text-secondary mr-1",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("preset-button", null, {
                  updateRegions: _vm.updateRegions,
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success ml-1",
                    on: { click: _vm.sendRegions },
                  },
                  [_vm._v("Go")]
                ),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }